import React, { useState } from "react";
import { questions, optionArray } from "./Data";
import "./GeneralHealth.css";

let a = 0,
  b = 0,
  c = 0,
  d = 0;

let count = 0;

function ScoreCard() {
  if (a > 5) count++;
  if (b > 5) count++;
  if (c > 5) count++;
  if (d > 5) count++;
  console.log(count);
  // <div className="result-div"></div>;
}

function GeneralHealthQuiz() {
  const [qno, setQno] = useState(0);
  let [ansArray] = useState([]);
  const [show, setShow] = useState(true);

  let ans = 0;

  function computeScore() {
    a =
      ansArray[0] +
      ansArray[1] +
      ansArray[2] +
      ansArray[3] +
      ansArray[4] +
      ansArray[5] +
      ansArray[6];

    b =
      ansArray[7] +
      ansArray[8] +
      ansArray[9] +
      ansArray[10] +
      ansArray[11] +
      ansArray[12] +
      ansArray[13];

    c =
      ansArray[14] +
      ansArray[15] +
      ansArray[16] +
      ansArray[17] +
      ansArray[18] +
      ansArray[19] +
      ansArray[20];

    d =
      ansArray[21] +
      ansArray[22] +
      ansArray[23] +
      ansArray[24] +
      ansArray[25] +
      ansArray[26] +
      ansArray[27];
  }

  function handleClick(e) {
    ans = parseInt(e.target.getAttribute("data-value"));
    ansArray.push(ans);
    setQno((prev) => prev + 1);
    if (qno + 1 === 30) {
      setShow(false);
      computeScore();
    }
  }

  return (
    <div className="screen-bg">
      {show ? (
        <div className="quiz-bg">
          <p>Question {qno + 1} of 28</p>
          <h3>{questions[qno]}</h3>
          <div className="answers">
            <div data-value="0" onClick={handleClick}>
              {optionArray[qno][0]}
            </div>
            <div data-value="0" onClick={handleClick}>
              {optionArray[qno][1]}
            </div>
            <div data-value="1" onClick={handleClick}>
              {optionArray[qno][2]}
            </div>
            <div data-value="1" onClick={handleClick}>
              {optionArray[qno][3]}
            </div>
          </div>
        </div>
      ) : (
        <ScoreCard />
      )}
      <br />
    </div>
  );
}

export default GeneralHealthQuiz;
